"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _urijs = _interopRequireDefault(require("urijs"));
var _experimentsPropTypes = require("./experimentsPropTypes");
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var TableCellDiv = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-right: 0px;\n  vertical-align: middle;\n  display: table-cell;\n"])));
var FooSpan = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 0px;\n  width: 140px;\n  cursor: default;\n  background-color: ", ";\n  :hover{\n    opacity: 1.0;\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.backgroundColor;
});

// TODO We should probably create an entry per experiment type so that instead of assays we show e.g. cells/contrasts
function LatestExperimentEntry(props) {
  var experimentType = props.experimentType,
    experimentAccession = props.experimentAccession,
    experimentDescription = props.experimentDescription,
    numberOfAssays = props.numberOfAssays,
    lastUpdate = props.lastUpdate,
    species = props.species,
    host = props.host;
  var experimentUrl = (0, _urijs["default"])("experiments/".concat(experimentAccession), host).toString();
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "block",
      marginBottom: "1rem"
    }
  }, !experimentType.startsWith("SINGLE_CELL") && /*#__PURE__*/_react["default"].createElement(TableCellDiv, null, /*#__PURE__*/_react["default"].createElement(FooSpan, {
    className: "button",
    backgroundColor: "#007c82"
  }, experimentType.endsWith("BASELINE") ? "Baseline" : "Differential")), /*#__PURE__*/_react["default"].createElement(TableCellDiv, {
    className: "hide-for-small-only"
  }, /*#__PURE__*/_react["default"].createElement(FooSpan, {
    className: "button",
    backgroundColor: "gray",
    style: {
      minWidth: "120px"
    },
    title: "Number of assays in experiment"
  }, numberOfAssays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), " assays")), /*#__PURE__*/_react["default"].createElement(TableCellDiv, {
    className: "hide-for-small-only"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "button",
    style: {
      marginBottom: "0px",
      backgroundColor: "#3497C5"
    },
    href: experimentUrl
  }, "Results")), /*#__PURE__*/_react["default"].createElement(TableCellDiv, {
    style: {
      paddingLeft: "1rem"
    }
  }, /*#__PURE__*/_react["default"].createElement("small", null, lastUpdate), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("a", {
    href: experimentUrl
  }, experimentDescription, " \u2013 ", /*#__PURE__*/_react["default"].createElement("i", null, species))));
}
LatestExperimentEntry.propTypes = _experimentsPropTypes.experimentPropTypes;
var _default = exports["default"] = LatestExperimentEntry;